import reducer from './reducers';

// export { claimsPageSelectors } from './selectors';

export default reducer;
